__turbopack_context__.v({
  "leftSection": "Modal-module__9sx2hq__leftSection",
  "rightSection": "Modal-module__9sx2hq__rightSection",
  "rightSectionContainer": "Modal-module__9sx2hq__rightSectionContainer",
  "rightSectionContainerItemsTop": "Modal-module__9sx2hq__rightSectionContainerItemsTop",
  "scLogoContainer": "Modal-module__9sx2hq__scLogoContainer",
});
